/* unplugin-vue-components disabled */import { render } from "./Test2.vue?vue&type=template&id=32d64a96&scoped=true&ts=true"
import script from "./Test2.vue?vue&type=script&lang=ts"
export * from "./Test2.vue?vue&type=script&lang=ts"

import "./Test2.vue?vue&type=style&index=0&id=32d64a96&scoped=true&lang=css"

import exportComponent from "D:\\Song\\Demo\\hxswmj\\hxswmj_vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d64a96"]])

export default __exports__